import type { MCarouselControlsType } from '../../molecules/MCarouselControls/MCarouselControls.types';

export enum OCardCarouselDesktopCards {
  One = '1',
  Two = '2',
  Three = '3',
  Four = '4',
  Six = '6',
}

export enum OCardCarouselTotalCards {
  One = '1',
  Two = '2',
  TwoPlus = '2+',
  Three = '3',
  ThreePlus = '3+',
  Four = '4',
  FourPlus = '4+',
  Six = '6',
  SixPlus = '6+',
}

export interface OCardCarouselMContentHeader {
  alignment?: 'Left' | 'Centered';
  mTextBlockSimple?: {
    alignment?: 'Left' | 'Centered';
    aEyebrow?: {
      eyebrowText?: string;
    };
    aHeader?: {
      size?: string;
      text?: string;
      headerTag?: string;
    };
    aBody?: {
      bodyText?: string;
      size?: string;
      color?: string;
    };
  };
  mButton?: {
    buttonText?: string;
    type?: string;
    ctaLink?: string;
    openInANewTab?: string;
    size?: string;
    icon?: string;
  };
  mButton2?: {
    buttonText?: string;
    type?: string;
    ctaLink?: string;
    openInANewTab?: string;
    size?: string;
    icon?: string;
  };
}

export interface OCardCarouselMCarouselControls {
  type?: MCarouselControlsType;
  imageOverlay?: string | boolean;
  arrows?: string | boolean;
  aIcon?: {
    size?: string;
    icon?: string;
  };
}

export interface OCardCarouselMSlot {
  [key: string]: unknown;
}

export interface OCardCarouselTrackingProperties {
  location?: string;
  trackingTag?: string;
  trackingContentPosition?: string;
  trackingDescription?: string;
  trackingOfferType?: string;
  merchandisingCategory?: string;
  atCCeVar48?: string;
  clickTrack?: boolean;
  impressionTrack?: boolean;
  impressionCount?: boolean;
  enableScrollingBehavior?: boolean;
  leftArrowDesc?: string;
  cardLocation?: string;
  rightArrowDesc?: string;
  description?: string;
  faicMCD?: string;
  additionalTrackingVariables?: string;
}

export interface OCardCarouselCqItem {
  ':type'?: string;
  [key: string]: unknown;
}

export interface OCardCarouselModel {
  cqItemsOrder?: string[];
  ':itemsOrder'?: string[];
  [key: string]: unknown;
}

export interface OCardCarouselProps {
  desktopCards?: string;
  totalCards?: string;
  mContentHeader?: OCardCarouselMContentHeader;
  mCarouselControls?: OCardCarouselMCarouselControls;
  mSlot?: OCardCarouselMSlot;
  pagePath?: string;
  itemPath?: string;
  isAuthorMode?: boolean;
  cqItems?: Record<string, OCardCarouselCqItem>;
  model?: OCardCarouselModel;
  aemReactComponentMapping?: Record<string, React.FC<Record<string, unknown>>>;
  className?: string;
  trackingProperties?: OCardCarouselTrackingProperties;
}
